import { PILOT_CONTENT_REGISTRY, type ContentRegistry } from "./content-registry";
import { parsePublicPathname } from "./paths";

export type MandarinJourneyPaths = Readonly<{
  home: string;
  course: string;
  visit: string;
}>;

export const PREVIEW_MANDARIN_JOURNEY_PATHS =
  Object.freeze({
    home: "/dev/mandarin-pilot",
    course: "/dev/mandarin-pilot/course",
    visit: "/dev/mandarin-pilot/visit",
  } as const satisfies MandarinJourneyPaths);

export const PUBLIC_MANDARIN_JOURNEY_PATHS =
  Object.freeze({
    home: "/zh",
    course: "/zh/practical-crash-course",
    visit: "/zh/locations/henderson",
  } as const satisfies MandarinJourneyPaths);

export const ENGLISH_JOURNEY_PATHS = Object.freeze({
  home: "/",
  course: "/practical-crash-course",
  visit: "/locations/henderson",
} as const satisfies MandarinJourneyPaths);

/** Build publication surfaces only from the registry's published versions. */
export function createMandarinPublication(registry: ContentRegistry) {
  const pairs = Object.freeze(registry.getRecords().flatMap(record => {
    const versions = registry.getPublishedVersions(record.id);
    const english = versions.find(version => version.locale === "en");
    const mandarin = versions.find(version => version.locale === "zh-Hans");
    return english && mandarin ? [Object.freeze({
      contentId: record.id, en: english.publicPath, zhHans: mandarin.publicPath,
    })] : [];
  }));
  const paths = new Set(pairs.map(pair => pair.zhHans));
  return Object.freeze({
    pairs,
    isPublishedPath(pathname: string): boolean {
      if (!paths.has(pathname)) return false;
      try { return parsePublicPathname(pathname).locale === "zh-Hans"; }
      catch { return false; }
    },
  });
}

const publication = createMandarinPublication(PILOT_CONTENT_REGISTRY);
export function isPublishedMandarinPath(pathname: string): boolean {
  return publication.isPublishedPath(pathname);
}
export function publishedMandarinPairs() { return publication.pairs; }
